export const categories = [
  {
    slug: "internal",
    name: "内部消息",
    enName: "Internal",
    icon: "ri-file-shield-2-line",
    count: 286,
    description:
      "来自组织内部的流程说明、通知文件与口径变化。适合提交不便公开身份的岗位见闻与内部沟通记录。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20still%20life%20of%20stacked%20folders%20and%20sealed%20envelope%20on%20warm%20paper%20desk%2C%20muted%20ink%20and%20cream%20tones%2C%20soft%20diffused%20daylight%2C%20abstract%20documentary%20photography%2C%20no%20text&width=800&height=600&seq=cat-internal-01&orientation=landscape",
  },
  {
    slug: "public-events",
    name: "公众事件",
    enName: "Public",
    icon: "ri-broadcast-line",
    count: 512,
    description:
      "正在被广泛讨论的公共议题。欢迎提交现场照片、通知原文与时间线补充，帮助还原事件前后因果。",
    image:
      "https://readdy.ai/api/search-image?query=editorial%20abstract%20city%20square%20scene%20at%20dusk%20with%20small%20crowd%20silhouettes%2C%20warm%20sepia%20and%20deep%20crimson%20tones%2C%20soft%20film%20grain%2C%20documentary%20photography%2C%20no%20text&width=800&height=600&seq=cat-public-01&orientation=landscape",
  },
  {
    slug: "daily",
    name: "身边事",
    enName: "Neighborhood",
    icon: "ri-home-5-line",
    count: 634,
    description:
      "社区、街道与日常生活中的小问题。路灯、井盖、噪音、垃圾清运——看似琐碎，却是很多人的共同困扰。",
    image:
      "https://readdy.ai/api/search-image?query=quiet%20residential%20alley%20at%20early%20morning%2C%20warm%20cream%20walls%20and%20long%20soft%20shadows%2C%20muted%20earthy%20palette%2C%20editorial%20abstract%20photography%2C%20no%20text%20no%20people&width=800&height=600&seq=cat-daily-01&orientation=landscape",
  },
  {
    slug: "rights",
    name: "维权线索",
    enName: "Rights",
    icon: "ri-scales-3-line",
    count: 389,
    description:
      "涉及合同、薪酬、物业、征收等权益争议的线索。提交时建议附上时间节点与已沟通对象，便于梳理。",
    image:
      "https://readdy.ai/api/search-image?query=close%20up%20of%20signed%20contract%20pages%20and%20reading%20glasses%20on%20warm%20linen%20surface%2C%20amber%20and%20ink%20tones%2C%20soft%20window%20light%2C%20editorial%20still%20life%2C%20no%20text&width=800&height=600&seq=cat-rights-01&orientation=landscape",
  },
  {
    slug: "consumer",
    name: "消费投诉",
    enName: "Consumer",
    icon: "ri-shopping-bag-3-line",
    count: 297,
    description:
      "预付费停业、宣传与实物不符、退费困难等消费纠纷。请尽量保留订单截图、聊天记录与承诺原文。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20flat%20lay%20of%20receipts%20shopping%20bag%20and%20card%20holder%20on%20warm%20beige%20paper%2C%20muted%20crimson%20accent%2C%20soft%20overhead%20light%2C%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=cat-consumer-01&orientation=landscape",
  },
  {
    slug: "industry",
    name: "行业观察",
    enName: "Industry",
    icon: "ri-line-chart-line",
    count: 254,
    description:
      "某类行业里反复出现、但少被公开讨论的现象。适合提交调研笔记、比价数据与从业者口述。",
    image:
      "https://readdy.ai/api/search-image?query=abstract%20industrial%20workspace%20with%20blueprint%20rolls%20and%20measuring%20tools%20on%20warm%20wood%2C%20ochre%20and%20charcoal%20palette%2C%20soft%20directional%20light%2C%20editorial%20photography%2C%20no%20text&width=800&height=600&seq=cat-industry-01&orientation=landscape",
  },
];

export default categories;